module.exports = __webpack_public_path__ + "media/src/public/img/payment/sberbank-logo-min-3fb47cab3e1201a4bccfe8acd55e45e9.svg";